import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import {
  GenericComponentsModule,
  ResizeHandleModule,
} from '@helios/generic-components'
import {
  NgbAlertModule,
  NgbModalModule,
  NgbNavModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap'
import { NgSelectModule } from '@ng-select/ng-select'
import { TableLayoutModule } from '@northfork/ag-grid-angular'
import {
  DaterangeModule,
  InlineEditModule,
  NfFormsModule,
} from '@northfork/ng-basics'
import { ContextMenuModule } from 'ngx-contextmenu'
import { ExternalFileViewerDetailsComponent } from './external-file-viewer-details/external-file-viewer-details.component'
import { ExternalFileViewerGridComponent } from './external-file-viewer-grid/external-file-viewer-grid.component'
import { ExternalFileViewerPanelComponent } from './external-file-viewer-panel.component'
@NgModule({
  imports: [
    CommonModule,
    TableLayoutModule,
    GenericComponentsModule,
    NgbModalModule,
    NgbNavModule,
    NfFormsModule,
    FormsModule,
    DaterangeModule,
    ResizeHandleModule,
    FormsModule,
    ReactiveFormsModule,
    InlineEditModule,
    NgSelectModule,
    ContextMenuModule.forRoot({
      useBootstrap4: true,
      autoFocus: true,
    }),
    NgbAlertModule,
    NgbTooltipModule,
  ],
  declarations: [
    ExternalFileViewerPanelComponent,
    ExternalFileViewerGridComponent,
    ExternalFileViewerDetailsComponent,
  ],
  exports: [ExternalFileViewerPanelComponent],
})
export class ExternalFileViewerModule {}

export { ExternalFileViewerPanelComponent }
